// Members area auth context — separate from admin AuthContext.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MemberAuthContext = createContext(null);

export function MemberAuthProvider({ children }) {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/members/me`, { withCredentials: true });
      setMember(r.data);
    } catch (e) {
      // 401 = not logged in, expected. Anything else is worth logging.
      if (e?.response?.status && e.response.status !== 401) {
        console.error("[MemberAuth] /me failed:", e.response.status, e.response?.data);
      }
      setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/membros/google-callback";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  const loginPassword = async (email, password) => {
    const r = await axios.post(
      `${API}/members/login`,
      { email, password },
      { withCredentials: true }
    );
    setMember(r.data.member);
    return r.data;
  };

  const register = async ({ email, password, name }) => {
    return (
      await axios.post(
        `${API}/members/register`,
        { email, password, name },
        { withCredentials: true }
      )
    ).data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/members/logout`, {}, { withCredentials: true });
    } catch (e) {
      console.warn("[MemberAuth] logout call failed (continuing client logout):", e?.message);
    }
    setMember(null);
    window.location.href = "/membros/login";
  };

  return (
    <MemberAuthContext.Provider value={{ member, loading, setMember, loginGoogle, loginPassword, register, logout, refresh: checkAuth }}>
      {children}
    </MemberAuthContext.Provider>
  );
}

export function useMemberAuth() {
  const ctx = useContext(MemberAuthContext);
  if (!ctx) throw new Error("useMemberAuth must be used within MemberAuthProvider");
  return ctx;
}

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erro";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
